import styled, { keyframes } from 'styled-components';

const ldsRing = keyframes`
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}`;

export const StyledWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 99999;
	background-color: ${({ theme }) => theme.base};
	display: flex;
	justify-content: center;
	align-items: center;

	.lds-ring {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;

		div {
			box-sizing: border-box;
			display: block;
			position: absolute;
			width: 64px;
			height: 64px;
			margin: 8px;
			border: 8px solid ${({ theme }) => theme.accent};
			border-radius: 50%;
			animation: ${ldsRing} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
			border-color: ${({ theme }) => theme.accent} transparent transparent
				transparent;

			&:nth-child(1) {
				animation-delay: -0.45s;
			}

			&:nth-child(2) {
				animation-delay: -0.3s;
			}

			&:nth-child(3) {
				animation-delay: -0.15s;
			}
		}
	}
`;
